import client from '../httpClient';

const webResGetApi = (params) => {
  return client.get('/responses', params);
};

export default webResGetApi;
